cv.hasUnsavedChanges = function() {
  var unsaved_changes = false;
  _.each(cv.unsaved_views, function(view, key, list){
    if(view.triggerMethod('hasUnsavedChanges')){
      unsaved_changes = true;
    }
  }, this);
  return unsaved_changes;
};